export const LOCALSTORAGE_KEY_REFERRAL = "10A_Referral"
export const GOAFFPRO_URL = process.env.GATSBY_GOAFFPRO_API_URL
export const GOAFFPRO_ACCESS_TOKEN =
  process.env.GATSBY_GOAFFPRO_API_ACCESS_TOKEN
export const GOAFFPRO_ACCESS_PUBLIC_KEY =
  process.env.GATSBY_GOAFFPRO_API_PUBLIC_KEY
